import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function viewTenantDetailreducer(state = initialState.ViewtenantDetails, action) {
    switch (action.type) {
        case types.LOAD_VIEW_TENANT_SUCCESSFULL: return {
           ...state,
            TenantDetails: action.getResponse.CompleteInfo,
            CompanyInformation: action.getResponse.CompanyInformation,
            HoursofOperation: action.getResponse.HoursOfOperation,
           // Zones: action.getResponse.HoursOfOperation,
            AfterHours: action.getResponse.AfterHours,
            Employees: action.getResponse.CompleteInfo.tenantUser,
            UsageMeters: action.getResponse.UsageMeters,
            FixedCharges: action.getResponse.FixedCharges,
            AddHoursPeriodFromModal: state.ModalAddHoursPeriod,

        };

        case types.PUT_TENANT_COMPANY_INFO_SUCCESSFULL: return {
            ...state,
             CompanyInformation: action.getResponse.CompanyInformation,
         };
         case types.GET_ZONES_BY_TENANT_ID: return {
            ...state,
            TenantZones: action.getResponse,
         };
         case types.GET_METERS_BY_TENANT_ID: return {
            ...state,
            UsageMeters: action.getResponse,
         };
         case types.PUT_TENANT_AFTER_HOURS_SUCCESSFULL: return {
            ...state,
            AfterHours: action.getResponse.AfterHours,
         };
         case types.PUT_TENANT_NORMAL_HOURS_SUCCESSFULL: return {
            ...state,
            HoursofOperation: action.getResponse.HoursOfOperation,
         };
        
         case types.ADD_HOURS_PERIOD_MODAL: return {
            ...state,
            AddHoursPeriodFromModal: action.Data,
         };
      
         case types.GET_IS_LOGONNAME_EXISTS: return {
            ...state,
            IsLogOnNameExists : action.getResponse
         };

         case types.GET_METERS_DATALOG: return{
            ...state,
            IsDataLogExistsForMeter : action.getResponse
         };

         case types.GET_DATALOG_FOR_METERS_OBJECTS: return{
            ...state,
            DatalogValueForMeterObject : action.getResponse
         };
        default : return state; 
    }   
}